import { useQuery } from 'react-query';
import { getRoles } from 'src/services/api/roles';

function useGetRoles(params) {
  return useQuery(['roles', params], () => getRoles(params), { cacheTime: 5 * 60 * 1000 });
}

export default useGetRoles;
